export class GetOriginsResponse {
  origins: string[];
  canCreateNew: boolean;

  constructor(origins: string[], canCreateNew?: boolean) {
    this.origins = origins;
    this.canCreateNew = canCreateNew;
  }
}
